import React from 'react';
import { PreviewFile } from './MediaViewer';
import { useAppContext } from '../../Services/AppContext';

interface MediaViewerDisplayNoneProps {
	file: PreviewFile;
}

export default function MediaViewerDisplayNone(
	props: MediaViewerDisplayNoneProps,
) {
	const { file } = props;
	const { translation } = useAppContext();

	return (
		<div className='text-center' style={{ marginTop: '20px' }}>
			{translation['component.mediaViewer.noPreviewAvailable']}
		</div>
	);
}
